import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    }, {
      path: '/product',
      name: 'product',
      component: () => import('@/pages/product/index'),
    }, {
      path: '/solve',
      name: 'solve',
      component: () => import('@/pages/solve/index'),
    }, {
      path: '/journalism',
      name: 'journalism',
      component: () => import('@/pages/journalism/index'),
    }, {
      path: '/journalism/jouDetails',
      name: 'jouDetails',
      component: () => import('@/pages/journalism/details'),
    },{
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about/index'),
    }, {
      path: '/cases',
      name: 'cases',
      component: () => import('@/pages/common/cases'),
    }, {
      path: '/cases/casesDetails',
      name: 'casesDetails',
      component: () => import('@/pages/common/casesDetails'),
    }, {
      path: '/search',
      name: 'search',
      component: () => import('@/pages/common/search'),
    }, {
      path: '/navigation',
      name: 'navigation',
      component: () => import('@/pages/common/navigation'),
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
})
//解决路由报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js